// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Tutorial1.css  —  KinetiQ CRE Course Notes Page
   Font system: Inter throughout — identical tokens, sizes,
   weights & letter-spacing to TutorialsDashboard.css
   ============================================================ */

   /* ─── Design tokens — mirrored from TutorialsDashboard.css ──── */
   :root {
     /* Backgrounds & surfaces */
     --t-bg:              #f7f9fa;      /* tdb-bg */
     --t-surface:         #ffffff;      /* tdb-surface */
     --t-panel:           #f3f4f6;
     --t-card:            #ffffff;
     --t-sidebar-bg:      #f0f2f4;
     --t-sidebar-header:  #e8eaed;
     --t-code-bg:         #f5f7fa;
     --t-eq-bg:           #fafbfc;
   
     /* Accent — green */
     --t-accent:          #28a745;      /* tdb-accent */
     --t-accent-dim:      rgba(40, 167, 69, 0.10);
     --t-accent-glow:     rgba(40, 167, 69, 0.15); /* tdb-accent-glow */
     --t-accent-hover:    #1e8c3a;      /* tdb-accent-hover */
   
     /* Semantic colours */
     --t-amber:           #b4690e;      /* tdb-amber */
     --t-amber-dim:       rgba(180, 105, 14, 0.08);
     --t-amber-border:    rgba(180, 105, 14, 0.22);
     --t-cyan:            #0891b2;
     --t-cyan-dim:        rgba(8, 145, 178, 0.08);
     --t-cyan-border:     rgba(8, 145, 178, 0.22);
     --t-blue:            #2563eb;
     --t-blue-dim:        rgba(37, 99, 235, 0.08);
     --t-blue-border:     rgba(37, 99, 235, 0.22);
     --t-green-dim:       rgba(40, 167, 69, 0.08);
     --t-green-border:    rgba(40, 167, 69, 0.22);
   
     /* Purple — tdb-purple */
     --t-purple:          #5624d0;      /* tdb-purple */
     --t-purple-light:    rgba(86, 36, 208, 0.07);  /* tdb-purple-light */
     --t-purple-border:   rgba(86, 36, 208, 0.18);  /* tdb-purple-border */
   
     /* Reactor type colours */
     --t-batch:           #b4690e;
     --t-cstr:            #c0392b;
     --t-pfr:             #2563eb;
     --t-pbr:             #28a745;
   
     /* Borders */
     --t-border:          #d1d7dc;      /* tdb-border */
     --t-border-light:    #e8ecef;      /* tdb-border-light */
     --t-border-mid:      #bbc1c8;
   
     /* Text — tdb-text scale */
     --t-text:            #1c1d1f;      /* tdb-text */
     --t-text-muted:      #4a4f5a;      /* tdb-text-muted */
     --t-text-mid:        #3a3f4a;
     --t-text-dim:        #6a6f73;      /* tdb-text-dim */
     --t-text-sub:        #8a8f96;
   
     /* Font — identical to tdb-font */
     --t-font:            'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
     --t-font-mono:       'Courier New', 'Courier', monospace;
   
     /* Spacing */
     --t-space-xs:  6px;
     --t-space-sm:  10px;
     --t-space-md:  16px;
     --t-space-lg:  24px;
     --t-space-xl:  40px;
     --t-space-2xl: 56px;
   
     /* Radii — tdb uses 6px (md), 4px (sm) */
     --t-radius-sm: 4px;
     --t-radius-md: 6px;
     --t-radius-lg: 8px;
   
     --t-sidebar-w: 260px;
   }
   
   /* ─── Reset ─────────────────────────────────────────────────── */
   *,
   *::before,
   *::after {
     box-sizing: border-box;
     margin: 0;
     padding: 0;
   }
   
   /* ─── Scrollbar ─────────────────────────────────────────────── */
   ::-webkit-scrollbar        { width: 5px; height: 5px; }
   ::-webkit-scrollbar-track  { background: transparent; }
   ::-webkit-scrollbar-thumb  { background: var(--t-border); border-radius: 3px; }
   ::-webkit-scrollbar-thumb:hover { background: var(--t-border-mid); }
   
   /* ─── Container ─────────────────────────────────────────────── */
   /* Base font matches TutorialsDashboard body: Inter 15px / 400 / 1.7 */
   .cre-container {
     font-family: var(--t-font);
     background:  var(--t-bg);
     color:       var(--t-text);
     display:     flex;
     height:      100%;
     width:       100%;
     font-size:   15px;
     line-height: 1.7;
     overflow:    hidden;
   }
   
   /* ─── Main ──────────────────────────────────────────────────── */
   .cre-main {
     flex:       1 1;
     overflow-y: auto;
     overflow-x: hidden;
     min-width:  0;
     animation:  fadeIn 0.25s ease;
   }
   
   .cre-main-inner {
     margin:  0 auto;
     padding: 52px 64px 88px;
   }
   
   /* ─── Hero ──────────────────────────────────────────────────── */
   .cre-hero {
     margin-bottom:  var(--t-space-2xl);
     padding-bottom: 32px;
     border-bottom:  2px solid var(--t-text);
   }
   
   /* Matches .tdb-header-tag exactly */
   .cre-hero-tag {
     font-family:    var(--t-font);
     font-size:      13px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t-purple);
     margin-bottom:  10px;
   }
   
   /* Matches .tdb-header-title exactly */
   .cre-hero h1 {
     font-family:    var(--t-font);
     font-size:      32px;
     font-weight:    800;
     line-height:    1.2;
     letter-spacing: -0.5px;
     margin-bottom:  12px;
     color:          var(--t-text);
   }
   
   /* Matches .tdb-header-desc exactly */
   .cre-hero-desc {
     font-family: var(--t-font);
     font-size:   16px;
     font-weight: 400;
     color:       var(--t-text-muted);
     max-width:   640px;
     line-height: 1.7;
     margin:      0;
   }
   
   .cre-hero-meta {
     display:    flex;
     gap:        24px;
     margin-top: 20px;
     flex-wrap:  wrap;
   }
   
   .cre-meta-item {
     font-family: var(--t-font);
     font-size:   12px;
     font-weight: 400;
     color:       var(--t-text-dim);
     display:     flex;
     align-items: center;
     gap:         6px;
   }
   
   .cre-meta-dot {
     width:         6px;
     height:        6px;
     border-radius: 50%;
     background:    var(--t-accent);
     display:       inline-block;
     flex-shrink:   0;
   }
   
   /* ─── TOC box ───────────────────────────────────────────────── */
   .cre-toc-box {
     background:    var(--t-surface);
     border:        1px solid var(--t-border);
     border-left:   3px solid var(--t-accent);
     border-radius: var(--t-radius-md);
     padding:       22px 26px;
     margin-bottom: 40px;
     box-shadow:    0 2px 8px rgba(0, 0, 0, 0.06);
   }
   
   /* Matches .tdb-card-tag label: 12px / 700 / uppercase / 0.8px tracking */
   .cre-toc-box h3 {
     font-family:    var(--t-font);
     font-size:      12px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.8px;
     color:          var(--t-accent);
     margin-bottom:  14px;
   }
   
   .cre-toc-grid {
     display:               grid;
     grid-template-columns: 1fr 1fr;
     gap:                   6px 24px;
   }
   
   /* Matches tdb-popup-bullets li: 13px / 400 / text-muted */
   .cre-toc-link {
     font-family:     var(--t-font);
     font-size:       13px;
     font-weight:     400;
     color:           var(--t-blue);
     text-decoration: none;
     display:         flex;
     align-items:     center;
     gap:             6px;
     padding:         2px 0;
     transition:      color 0.15s;
   }
   .cre-toc-link:hover { color: var(--t-accent); }
   
   /* ─── Sections ──────────────────────────────────────────────── */
   .cre-section {
     margin-bottom:    var(--t-space-2xl);
     scroll-margin-top: 24px;
   }
   
   /* Matches .tdb-badge: 12px / 700 / 0.2px tracking / 3px 9px padding */
   .cre-lec-badge {
     display:        inline-block;
     font-family:    var(--t-font);
     font-size:      12px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.2px;
     padding:        3px 9px;
     border-radius:  var(--t-radius-sm);
     margin-bottom:  14px;
   }
   .cre-lec-badge--lec1 {
     background: rgba(180, 105, 14, 0.08);
     color:      var(--t-amber);
     border:     1px solid var(--t-amber-border);
   }
   .cre-lec-badge--lec8 {
     background: var(--t-blue-dim);
     color:      var(--t-blue);
     border:     1px solid var(--t-blue-border);
   }
   
   /* Matches .tdb-header-tag / tdb-card-tag label style */
   .cre-section-label {
     font-family:    var(--t-font);
     font-size:      13px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t-purple);
     margin-bottom:  8px;
   }
   
   /* Matches tdb section heading style: 26px / 800 / -0.3px tracking */
   .cre-section h2 {
     font-family:    var(--t-font);
     font-size:      26px;
     font-weight:    800;
     letter-spacing: -0.3px;
     color:          var(--t-text);
     margin-bottom:  6px;
     line-height:    1.25;
   }
   
   .cre-section-divider {
     width:         40px;
     height:        3px;
     background:    var(--t-accent);
     margin-bottom: 22px;
     border-radius: 2px;
   }
   
   /* Matches .tdb-card-title: 17px / 700 / -0.1px tracking */
   .cre-section h3 {
     font-family:    var(--t-font);
     font-size:      17px;
     font-weight:    700;
     letter-spacing: -0.1px;
     color:          var(--t-text);
     margin:         28px 0 10px;
   }
   
   /* Body copy — matches tdb-card-desc base: 400 weight, 1.65 lh, text-muted */
   .cre-section p {
     font-family:   var(--t-font);
     font-size:     15px;
     font-weight:   400;
     margin-bottom: 14px;
     color:         var(--t-text-muted);
     line-height:   1.7;
   }
   
   /* Matches tdb-popup-bullets: 400, text-muted, 1.55 lh */
   .cre-section ul,
   .cre-section ol {
     font-family:   var(--t-font);
     font-size:     14px;
     font-weight:   400;
     padding-left:  20px;
     margin-bottom: 14px;
     color:         var(--t-text-muted);
     line-height:   1.65;
   }
   
   .cre-section li { margin-bottom: 6px; }
   
   /* ─── Equation box ──────────────────────────────────────────── */
   .cre-eq-box {
     background:    var(--t-eq-bg);
     border:        1px solid var(--t-border);
     border-left:   3px solid var(--t-amber);
     border-radius: var(--t-radius-md);
     padding:       18px 22px;
     margin:        18px 0;
     overflow-x:    auto;
   }
   
   .cre-eq-label {
     font-family:    var(--t-font);
     font-size:      11px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 1.5px;
     color:          var(--t-text-dim);
     margin-bottom:  8px;
   }
   
   .cre-eq-main {
     font-family: var(--t-font-mono);
     font-size:   14px;
     color:       var(--t-blue);
     line-height: 2;
   }
   
   .cre-eq-note {
     font-family: var(--t-font);
     font-size:   12px;
     font-weight: 400;
     color:       var(--t-text-dim);
     margin-top:  8px;
     line-height: 1.6;
   }
   
   /* Matches .tdb-popup-desc: 14px / 400 / 1.65 / text-muted */
   .cre-callout {
     border-radius: var(--t-radius-md);
     padding:       14px 18px;
     margin:        18px 0;
     line-height:   1.65;
   }
   .cre-callout p {
     font-family: var(--t-font);
     font-size:   14px;
     font-weight: 400;
     color:       var(--t-text-muted);
     margin:      0;
     line-height: 1.65;
   }
   .cre-callout--key  { background: var(--t-blue-dim);  border: 1px solid var(--t-blue-border);  }
   .cre-callout--warn { background: var(--t-amber-dim); border: 1px solid var(--t-amber-border); }
   .cre-callout--tip  { background: var(--t-green-dim); border: 1px solid var(--t-green-border); }
   .cre-callout--info { background: var(--t-cyan-dim);  border: 1px solid var(--t-cyan-border);  }
   
   /* ─── Card grid ─────────────────────────────────────────────── */
   .cre-card-grid {
     display:               grid;
     grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
     gap:                   14px;
     margin:                20px 0;
   }
   
   .cre-card {
     background:    var(--t-surface);
     border:        1px solid var(--t-border);
     border-radius: var(--t-radius-md);
     padding:       16px 18px;
     transition:    border-color 0.18s, box-shadow 0.18s, transform 0.18s;
     box-shadow:    0 2px 6px rgba(0, 0, 0, 0.06);
   }
   .cre-card:hover {
     border-color: var(--t-accent);
     box-shadow:   0 8px 28px rgba(0, 0, 0, 0.10);
     transform:    translateY(-2px);
   }
   
   .cre-card-icon {
     font-size:     22px;
     margin-bottom: 8px;
   }
   /* Matches .tdb-card-title: 17px / 700 / -0.1px */
   .cre-card h4 {
     font-family:    var(--t-font);
     font-size:      17px;
     font-weight:    700;
     color:          var(--t-text);
     margin-bottom:  6px;
     letter-spacing: -0.1px;
   }
   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */
   .cre-card p {
     font-family: var(--t-font);
     font-size:   14px;
     font-weight: 400;
     color:       var(--t-text-muted);
     margin:      0;
     line-height: 1.65;
   }
   
   /* ─── Steps list ────────────────────────────────────────────── */
   .cre-steps { margin: 20px 0; }
   
   .cre-step {
     display:       flex;
     gap:           16px;
     margin-bottom: 20px;
     align-items:   flex-start;
   }
   
   .cre-step-num {
     min-width:       32px;
     height:          32px;
     background:      var(--t-accent);
     color:           #fff;
     border-radius:   50%;
     display:         flex;
     align-items:     center;
     justify-content: center;
     font-family:     var(--t-font);
     font-weight:     700;
     font-size:       13px;
     margin-top:      2px;
     flex-shrink:     0;
     box-shadow:      0 2px 8px var(--t-accent-glow);
   }
   
   .cre-step-content { flex: 1 1; }
   /* Matches .tdb-card-title: 17px / 700 / -0.1px */
   .cre-step-content h4 {
     font-family:    var(--t-font);
     font-size:      17px;
     font-weight:    700;
     color:          var(--t-text);
     margin-bottom:  6px;
     letter-spacing: -0.1px;
   }
   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */
   .cre-step-content p {
     font-family: var(--t-font);
     font-size:   14px;
     font-weight: 400;
     color:       var(--t-text-muted);
     margin:      0 0 8px;
     line-height: 1.65;
   }
   
   /* ─── Example box ───────────────────────────────────────────── */
   .cre-example-box {
     background:    var(--t-surface);
     border:        1px solid var(--t-border);
     border-top:    3px solid var(--t-accent);
     border-radius: var(--t-radius-md);
     padding:       20px 24px;
     margin:        20px 0;
     box-shadow:    0 2px 6px rgba(0, 0, 0, 0.06);
   }
   
   /* Matches .tdb-badge: 12px / 700 / 0.2px tracking */
   .cre-example-tag {
     font-family:    var(--t-font);
     font-size:      12px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.2px;
     color:          var(--t-accent);
     margin-bottom:  8px;
   }
   
   /* Matches .tdb-card-title: 17px / 700 / -0.1px */
   .cre-example-box h4 {
     font-family:    var(--t-font);
     font-size:      17px;
     font-weight:    700;
     color:          var(--t-text);
     margin-bottom:  10px;
     letter-spacing: -0.1px;
   }
   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */
   .cre-example-box p {
     font-family:   var(--t-font);
     font-size:     14px;
     font-weight:   400;
     color:         var(--t-text-muted);
     margin-bottom: 10px;
     line-height:   1.65;
   }
   
   /* ─── Tables ────────────────────────────────────────────────── */
   .cre-table {
     width:           100%;
     border-collapse: collapse;
     margin:          20px 0;
     font-family:     var(--t-font);
     font-size:       13px;
     background:      var(--t-surface);
     border-radius:   var(--t-radius-md);
     overflow:        hidden;
     border:          1px solid var(--t-border);
   }
   
   .cre-table thead { background: var(--t-panel); }
   /* th: matches tdb-card-tag label (11px/700/uppercase/0.8px) */
   .cre-table th {
     padding:        10px 14px;
     text-align:     left;
     font-family:    var(--t-font);
     font-size:      11px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 0.8px;
     color:          var(--t-text-muted);
     border-bottom:  1px solid var(--t-border);
   }
   /* td: matches tdb-popup-bullets (13px/400/1.55/text-muted) */
   .cre-table td {
     font-family:    var(--t-font);
     font-size:      13px;
     font-weight:    400;
     padding:        10px 14px;
     border-bottom:  1px solid var(--t-border-light);
     color:          var(--t-text-muted);
     vertical-align: top;
     line-height:    1.55;
   }
   .cre-table tr:last-child td { border-bottom: none; }
   .cre-table tr:hover td { background: rgba(40, 167, 69, 0.03); }
   
   /* ─── Reactor cards ─────────────────────────────────────────── */
   .cre-reactor-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin: 20px 0; }
   
   .cre-reactor-card {
     background:    var(--t-surface);
     border:        1px solid var(--t-border);
     border-radius: var(--t-radius-md);
     overflow:      hidden;
     box-shadow:    0 2px 6px rgba(0, 0, 0, 0.06);
   }
   
   /* Matches tdb badge/tag label: 11px / 700 / uppercase / 1.5px tracking */
   .cre-reactor-header {
     padding:        12px 16px;
     font-family:    var(--t-font);
     font-size:      11px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 1.5px;
   }
   .cre-reactor-header--batch { background: rgba(180, 105, 14, 0.08); color: var(--t-batch); border-bottom: 1px solid rgba(180, 105, 14, 0.18); }
   .cre-reactor-header--cstr  { background: rgba(192, 57, 43, 0.08);  color: var(--t-cstr);  border-bottom: 1px solid rgba(192, 57, 43, 0.18); }
   .cre-reactor-header--pfr   { background: var(--t-blue-dim);        color: var(--t-pfr);   border-bottom: 1px solid var(--t-blue-border); }
   .cre-reactor-header--pbr   { background: var(--t-green-dim);       color: var(--t-pbr);   border-bottom: 1px solid var(--t-green-border); }
   
   .cre-reactor-body { padding: 14px 16px; }
   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */
   .cre-reactor-body p {
     font-family:   var(--t-font);
     font-size:     14px;
     font-weight:   400;
     color:         var(--t-text-muted);
     margin-bottom: 10px;
     line-height:   1.65;
   }
   .cre-reactor-eq {
     font-family:   var(--t-font-mono);
     font-size:     13px;
     color:         var(--t-text-mid);
     background:    var(--t-code-bg);
     border:        1px solid var(--t-border-light);
     border-radius: var(--t-radius-sm);
     padding:       8px 12px;
     margin-top:    8px;
   }
   .cre-reactor-eq span { color: var(--t-blue); }
   
   /* ─── Lecture divider ───────────────────────────────────────── */
   .cre-lecture-divider {
     border-top:  2px solid var(--t-text);
     margin:      48px 0 40px;
     padding-top: 40px;
   }
   /* Matches .tdb-header-tag exactly */
   .cre-lecture-label {
     font-family:    var(--t-font);
     font-size:      13px;
     font-weight:    700;
     text-transform: uppercase;
     letter-spacing: 2px;
     color:          var(--t-purple);
     margin-bottom:  8px;
   }
   /* Matches .tdb-header-title: 32px / 800 / -0.5px */
   .cre-lecture-divider h2 {
     font-family:    var(--t-font);
     font-size:      32px;
     font-weight:    800;
     letter-spacing: -0.5px;
     color:          var(--t-text);
     margin-bottom:  8px;
     line-height:    1.2;
   }
   /* Matches .tdb-header-desc: 16px / 400 / 1.7 */
   .cre-lecture-divider p {
     font-family: var(--t-font);
     font-size:   16px;
     font-weight: 400;
     color:       var(--t-text-muted);
     max-width:   640px;
     line-height: 1.7;
     margin:      0;
   }
   
   /* ─── Inline code ───────────────────────────────────────────── */
   .cre-inline-code {
     font-family:   var(--t-font-mono);
     font-size:     0.88em;
     background:    var(--t-code-bg);
     color:         var(--t-blue);
     padding:       2px 6px;
     border-radius: var(--t-radius-sm);
     border:        1px solid var(--t-border-light);
   }
   .cre-mono {
     font-family: var(--t-font-mono);
     color:       var(--t-blue);
   }
   
   /* ─── Footer ────────────────────────────────────────────────── */
   .cre-footer {
     border-top:  1px solid var(--t-border-light);
     padding-top: 24px;
     margin-top:  40px;
     font-family: var(--t-font);
     font-size:   12px;
     font-weight: 400;
     color:       var(--t-text-dim);
     line-height: 1.6;
   }
   
   /* ─── Images & Diagrams ─────────────────────────────────────── */
   img {
     max-width: 100%;
     height: auto;
     display: block;
     margin: 20px auto;
     border-radius: var(--t-radius-md);
     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
     transition: transform 0.2s ease, box-shadow 0.2s ease;
     border: 1px solid var(--t-border-light);
   }
   
   img:hover {
     transform: translateY(-2px);
     box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
   }
   
   .cre-section img {
     margin: 20px auto;
     max-width: 90%;
   }
   
   /* Image container for diagrams */
   div[style*="textAlign: center"] > img {
     display: block;
     margin: 16px auto;
   }
   
   .diagram-caption {
     font-family: var(--t-font);
     font-size: 12px;
     color: var(--t-text-dim);
     text-align: center;
     margin-top: 8px;
     font-style: italic;
   }
   
   /* ─── Animation ─────────────────────────────────────────────── */
   @keyframes fadeIn {
     from { opacity: 0; transform: translateY(8px); }
     to   { opacity: 1; transform: translateY(0); }
   }
   
   /* ─── Responsive ────────────────────────────────────────────── */
   @media (max-width: 1200px) {
     .cre-main-inner { padding: 40px 40px 64px; }
   }
   
   @media (max-width: 900px) {
     .cre-sidebar { display: none !important; }
     .cre-main-inner {
       padding:   28px 20px 52px;
       max-width: 100%;
     }
     .cre-reactor-grid,
     .cre-toc-grid { grid-template-columns: 1fr; }
     .cre-hero h1 { font-size: 26px; }
     .cre-hero-desc { font-size: 15px; }
   }
   
   @media (max-width: 600px) {
     .cre-card-grid { grid-template-columns: 1fr; }
   }`, "",{"version":3,"sources":["webpack://./src/styles/Tutorial1.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;GAI9D,kEAAkE;GAClE;KACE,2BAA2B;KAC3B,4BAA4B,OAAO,WAAW;KAC9C,4BAA4B,OAAO,gBAAgB;KACnD,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;;KAE5B,mBAAmB;KACnB,4BAA4B,OAAO,eAAe;KAClD,4CAA4C;KAC5C,4CAA4C,EAAE,oBAAoB;KAClE,4BAA4B,OAAO,qBAAqB;;KAExD,qBAAqB;KACrB,4BAA4B,OAAO,cAAc;KACjD,6CAA6C;KAC7C,6CAA6C;KAC7C,4BAA4B;KAC5B,4CAA4C;KAC5C,4CAA4C;KAC5C,4BAA4B;KAC5B,4CAA4C;KAC5C,4CAA4C;KAC5C,4CAA4C;KAC5C,4CAA4C;;KAE5C,wBAAwB;KACxB,4BAA4B,OAAO,eAAe;KAClD,4CAA4C,GAAG,qBAAqB;KACpE,4CAA4C,GAAG,sBAAsB;;KAErE,yBAAyB;KACzB,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;KAC5B,4BAA4B;;KAE5B,YAAY;KACZ,4BAA4B,OAAO,eAAe;KAClD,4BAA4B,OAAO,qBAAqB;KACxD,4BAA4B;;KAE5B,0BAA0B;KAC1B,4BAA4B,OAAO,aAAa;KAChD,4BAA4B,OAAO,mBAAmB;KACtD,4BAA4B;KAC5B,4BAA4B,OAAO,iBAAiB;KACpD,4BAA4B;;KAE5B,iCAAiC;KACjC,uFAAuF;KACvF,wDAAwD;;KAExD,YAAY;KACZ,kBAAkB;KAClB,mBAAmB;KACnB,mBAAmB;KACnB,mBAAmB;KACnB,mBAAmB;KACnB,mBAAmB;;KAEnB,wCAAwC;KACxC,kBAAkB;KAClB,kBAAkB;KAClB,kBAAkB;;KAElB,oBAAoB;GACtB;;GAEA,kEAAkE;GAClE;;;KAGE,sBAAsB;KACtB,SAAS;KACT,UAAU;GACZ;;GAEA,kEAAkE;GAClE,6BAA6B,UAAU,EAAE,WAAW,EAAE;GACtD,6BAA6B,uBAAuB,EAAE;GACtD,6BAA6B,2BAA2B,EAAE,kBAAkB,EAAE;GAC9E,kCAAkC,+BAA+B,EAAE;;GAEnE,kEAAkE;GAClE,sEAAsE;GACtE;KACE,0BAA0B;KAC1B,wBAAwB;KACxB,0BAA0B;KAC1B,iBAAiB;KACjB,iBAAiB;KACjB,iBAAiB;KACjB,iBAAiB;KACjB,gBAAgB;KAChB,mBAAmB;GACrB;;GAEA,kEAAkE;GAClE;KACE,eAAa;KACb,gBAAgB;KAChB,kBAAkB;KAClB,aAAa;KACb,6BAA6B;GAC/B;;GAEA;KACE,eAAe;KACf,uBAAuB;GACzB;;GAEA,kEAAkE;GAClE;KACE,kCAAkC;KAClC,oBAAoB;KACpB,uCAAuC;GACzC;;GAEA,oCAAoC;GACpC;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,mBAAmB;KACnB,+BAA+B;KAC/B,oBAAoB;GACtB;;GAEA,sCAAsC;GACtC;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,mBAAmB;KACnB,sBAAsB;KACtB,oBAAoB;KACpB,6BAA6B;GAC/B;;GAEA,qCAAqC;GACrC;KACE,0BAA0B;KAC1B,iBAAiB;KACjB,gBAAgB;KAChB,gCAAgC;KAChC,kBAAkB;KAClB,gBAAgB;KAChB,cAAc;GAChB;;GAEA;KACE,gBAAgB;KAChB,gBAAgB;KAChB,gBAAgB;KAChB,gBAAgB;GAClB;;GAEA;KACE,0BAA0B;KAC1B,iBAAiB;KACjB,gBAAgB;KAChB,8BAA8B;KAC9B,iBAAiB;KACjB,mBAAmB;KACnB,gBAAgB;GAClB;;GAEA;KACE,kBAAkB;KAClB,kBAAkB;KAClB,kBAAkB;KAClB,8BAA8B;KAC9B,2BAA2B;KAC3B,gBAAgB;GAClB;;GAEA,kEAAkE;GAClE;KACE,+BAA+B;KAC/B,wCAAwC;KACxC,wCAAwC;KACxC,iCAAiC;KACjC,wBAAwB;KACxB,mBAAmB;KACnB,4CAA4C;GAC9C;;GAEA,yEAAyE;GACzE;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,+BAA+B;KAC/B,oBAAoB;GACtB;;GAEA;KACE,2BAA2B;KAC3B,8BAA8B;KAC9B,+BAA+B;GACjC;;GAEA,0DAA0D;GAC1D;KACE,8BAA8B;KAC9B,qBAAqB;KACrB,oBAAoB;KACpB,8BAA8B;KAC9B,qBAAqB;KACrB,qBAAqB;KACrB,uBAAuB;KACvB,oBAAoB;KACpB,sBAAsB;KACtB,4BAA4B;GAC9B;GACA,sBAAsB,sBAAsB,EAAE;;GAE9C,kEAAkE;GAClE;KACE,oCAAoC;KACpC,uBAAuB;GACzB;;GAEA,sEAAsE;GACtE;KACE,4BAA4B;KAC5B,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,uBAAuB;KACvB,kCAAkC;KAClC,oBAAoB;GACtB;GACA;KACE,oCAAoC;KACpC,0BAA0B;KAC1B,2CAA2C;GAC7C;GACA;KACE,6BAA6B;KAC7B,yBAAyB;KACzB,0CAA0C;GAC5C;;GAEA,uDAAuD;GACvD;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,mBAAmB;KACnB,+BAA+B;KAC/B,mBAAmB;GACrB;;GAEA,oEAAoE;GACpE;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,sBAAsB;KACtB,6BAA6B;KAC7B,mBAAmB;KACnB,oBAAoB;GACtB;;GAEA;KACE,mBAAmB;KACnB,kBAAkB;KAClB,8BAA8B;KAC9B,mBAAmB;KACnB,kBAAkB;GACpB;;GAEA,0DAA0D;GAC1D;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,sBAAsB;KACtB,6BAA6B;KAC7B,2BAA2B;GAC7B;;GAEA,4EAA4E;GAC5E;KACE,4BAA4B;KAC5B,mBAAmB;KACnB,kBAAkB;KAClB,mBAAmB;KACnB,kCAAkC;KAClC,kBAAkB;GACpB;;GAEA,wDAAwD;GACxD;;KAEE,4BAA4B;KAC5B,mBAAmB;KACnB,kBAAkB;KAClB,mBAAmB;KACnB,mBAAmB;KACnB,kCAAkC;KAClC,mBAAmB;GACrB;;GAEA,kBAAkB,kBAAkB,EAAE;;GAEtC,kEAAkE;GAClE;KACE,6BAA6B;KAC7B,wCAAwC;KACxC,uCAAuC;KACvC,iCAAiC;KACjC,wBAAwB;KACxB,qBAAqB;KACrB,mBAAmB;GACrB;;GAEA;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,iCAAiC;KACjC,mBAAmB;GACrB;;GAEA;KACE,+BAA+B;KAC/B,iBAAiB;KACjB,0BAA0B;KAC1B,cAAc;GAChB;;GAEA;KACE,0BAA0B;KAC1B,iBAAiB;KACjB,gBAAgB;KAChB,8BAA8B;KAC9B,gBAAgB;KAChB,gBAAgB;GAClB;;GAEA,4DAA4D;GAC5D;KACE,iCAAiC;KACjC,wBAAwB;KACxB,qBAAqB;KACrB,mBAAmB;GACrB;GACA;KACE,0BAA0B;KAC1B,iBAAiB;KACjB,gBAAgB;KAChB,gCAAgC;KAChC,cAAc;KACd,iBAAiB;GACnB;GACA,qBAAqB,6BAA6B,GAAG,sCAAsC,GAAG;GAC9F,qBAAqB,8BAA8B,EAAE,uCAAuC,EAAE;GAC9F,qBAAqB,8BAA8B,EAAE,uCAAuC,EAAE;GAC9F,qBAAqB,6BAA6B,GAAG,sCAAsC,GAAG;;GAE9F,kEAAkE;GAClE;KACE,2BAA2B;KAC3B,4DAA4D;KAC5D,2BAA2B;KAC3B,6BAA6B;GAC/B;;GAEA;KACE,+BAA+B;KAC/B,wCAAwC;KACxC,iCAAiC;KACjC,wBAAwB;KACxB,oEAAoE;KACpE,4CAA4C;GAC9C;GACA;KACE,6BAA6B;KAC7B,4CAA4C;KAC5C,8BAA8B;GAChC;;GAEA;KACE,mBAAmB;KACnB,kBAAkB;GACpB;GACA,iDAAiD;GACjD;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,6BAA6B;KAC7B,mBAAmB;KACnB,sBAAsB;GACxB;GACA,8CAA8C;GAC9C;KACE,0BAA0B;KAC1B,iBAAiB;KACjB,gBAAgB;KAChB,gCAAgC;KAChC,cAAc;KACd,iBAAiB;GACnB;;GAEA,kEAAkE;GAClE,aAAa,cAAc,EAAE;;GAE7B;KACE,mBAAmB;KACnB,mBAAmB;KACnB,mBAAmB;KACnB,yBAAyB;GAC3B;;GAEA;KACE,qBAAqB;KACrB,qBAAqB;KACrB,gCAAgC;KAChC,qBAAqB;KACrB,oBAAoB;KACpB,qBAAqB;KACrB,uBAAuB;KACvB,uBAAuB;KACvB,8BAA8B;KAC9B,oBAAoB;KACpB,qBAAqB;KACrB,oBAAoB;KACpB,kBAAkB;KAClB,+CAA+C;GACjD;;GAEA,oBAAoB,SAAO,EAAE;GAC7B,iDAAiD;GACjD;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,6BAA6B;KAC7B,mBAAmB;KACnB,sBAAsB;GACxB;GACA,8CAA8C;GAC9C;KACE,0BAA0B;KAC1B,iBAAiB;KACjB,gBAAgB;KAChB,gCAAgC;KAChC,oBAAoB;KACpB,iBAAiB;GACnB;;GAEA,kEAAkE;GAClE;KACE,+BAA+B;KAC/B,wCAAwC;KACxC,wCAAwC;KACxC,iCAAiC;KACjC,wBAAwB;KACxB,qBAAqB;KACrB,4CAA4C;GAC9C;;GAEA,oDAAoD;GACpD;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,+BAA+B;KAC/B,mBAAmB;GACrB;;GAEA,iDAAiD;GACjD;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,6BAA6B;KAC7B,oBAAoB;KACpB,sBAAsB;GACxB;GACA,8CAA8C;GAC9C;KACE,4BAA4B;KAC5B,mBAAmB;KACnB,kBAAkB;KAClB,kCAAkC;KAClC,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA,kEAAkE;GAClE;KACE,qBAAqB;KACrB,yBAAyB;KACzB,uBAAuB;KACvB,8BAA8B;KAC9B,qBAAqB;KACrB,iCAAiC;KACjC,mCAAmC;KACnC,uBAAuB;KACvB,0CAA0C;GAC5C;;GAEA,mBAAmB,0BAA0B,EAAE;GAC/C,8DAA8D;GAC9D;KACE,yBAAyB;KACzB,oBAAoB;KACpB,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;KACrB,mCAAmC;KACnC,yCAAyC;GAC3C;GACA,6DAA6D;GAC7D;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,+CAA+C;KAC/C,mCAAmC;KACnC,mBAAmB;KACnB,oBAAoB;GACtB;GACA,8BAA8B,mBAAmB,EAAE;GACnD,yBAAyB,mCAAmC,EAAE;;GAE9D,kEAAkE;GAClE,oBAAoB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,cAAc,EAAE;;GAE9F;KACE,+BAA+B;KAC/B,wCAAwC;KACxC,iCAAiC;KACjC,qBAAqB;KACrB,4CAA4C;GAC9C;;GAEA,yEAAyE;GACzE;KACE,yBAAyB;KACzB,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,qBAAqB;GACvB;GACA,6BAA6B,oCAAoC,EAAE,qBAAqB,EAAE,iDAAiD,EAAE;GAC7I,6BAA6B,mCAAmC,GAAG,oBAAoB,GAAG,gDAAgD,EAAE;GAC5I,6BAA6B,6BAA6B,SAAS,mBAAmB,IAAI,6CAA6C,EAAE;GACzI,6BAA6B,8BAA8B,QAAQ,mBAAmB,IAAI,8CAA8C,EAAE;;GAE1I,oBAAoB,kBAAkB,EAAE;GACxC,8CAA8C;GAC9C;KACE,4BAA4B;KAC5B,mBAAmB;KACnB,kBAAkB;KAClB,kCAAkC;KAClC,mBAAmB;KACnB,mBAAmB;GACrB;GACA;KACE,iCAAiC;KACjC,mBAAmB;KACnB,gCAAgC;KAChC,+BAA+B;KAC/B,8CAA8C;KAC9C,iCAAiC;KACjC,uBAAuB;KACvB,kBAAkB;GACpB;GACA,uBAAuB,oBAAoB,EAAE;;GAE7C,kEAAkE;GAClE;KACE,oCAAoC;KACpC,wBAAwB;KACxB,iBAAiB;GACnB;GACA,oCAAoC;GACpC;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,yBAAyB;KACzB,mBAAmB;KACnB,+BAA+B;KAC/B,mBAAmB;GACrB;GACA,mDAAmD;GACnD;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,mBAAmB;KACnB,sBAAsB;KACtB,6BAA6B;KAC7B,mBAAmB;KACnB,mBAAmB;GACrB;GACA,+CAA+C;GAC/C;KACE,0BAA0B;KAC1B,iBAAiB;KACjB,gBAAgB;KAChB,gCAAgC;KAChC,kBAAkB;KAClB,gBAAgB;KAChB,cAAc;GAChB;;GAEA,kEAAkE;GAClE;KACE,iCAAiC;KACjC,qBAAqB;KACrB,+BAA+B;KAC/B,4BAA4B;KAC5B,sBAAsB;KACtB,iCAAiC;KACjC,8CAA8C;GAChD;GACA;KACE,+BAA+B;KAC/B,0BAA0B;GAC5B;;GAEA,kEAAkE;GAClE;KACE,4CAA4C;KAC5C,iBAAiB;KACjB,iBAAiB;KACjB,0BAA0B;KAC1B,iBAAiB;KACjB,gBAAgB;KAChB,8BAA8B;KAC9B,gBAAgB;GAClB;;GAEA,kEAAkE;GAClE;KACE,eAAe;KACf,YAAY;KACZ,cAAc;KACd,iBAAiB;KACjB,iCAAiC;KACjC,yCAAyC;KACzC,qDAAqD;KACrD,uCAAuC;GACzC;;GAEA;KACE,2BAA2B;KAC3B,0CAA0C;GAC5C;;GAEA;KACE,iBAAiB;KACjB,cAAc;GAChB;;GAEA,iCAAiC;GACjC;KACE,cAAc;KACd,iBAAiB;GACnB;;GAEA;KACE,0BAA0B;KAC1B,eAAe;KACf,wBAAwB;KACxB,kBAAkB;KAClB,eAAe;KACf,kBAAkB;GACpB;;GAEA,kEAAkE;GAClE;KACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;KAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;GAC/C;;GAEA,kEAAkE;GAClE;KACE,kBAAkB,uBAAuB,EAAE;GAC7C;;GAEA;KACE,eAAe,wBAAwB,EAAE;KACzC;OACE,yBAAyB;OACzB,eAAe;KACjB;KACA;qBACgB,0BAA0B,EAAE;KAC5C,eAAe,eAAe,EAAE;KAChC,iBAAiB,eAAe,EAAE;GACpC;;GAEA;KACE,iBAAiB,0BAA0B,EAAE;GAC/C","sourcesContent":["/* ============================================================\n   Tutorial1.css  —  KinetiQ CRE Course Notes Page\n   Font system: Inter throughout — identical tokens, sizes,\n   weights & letter-spacing to TutorialsDashboard.css\n   ============================================================ */\n\n   @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');\n\n   /* ─── Design tokens — mirrored from TutorialsDashboard.css ──── */\n   :root {\n     /* Backgrounds & surfaces */\n     --t-bg:              #f7f9fa;      /* tdb-bg */\n     --t-surface:         #ffffff;      /* tdb-surface */\n     --t-panel:           #f3f4f6;\n     --t-card:            #ffffff;\n     --t-sidebar-bg:      #f0f2f4;\n     --t-sidebar-header:  #e8eaed;\n     --t-code-bg:         #f5f7fa;\n     --t-eq-bg:           #fafbfc;\n   \n     /* Accent — green */\n     --t-accent:          #28a745;      /* tdb-accent */\n     --t-accent-dim:      rgba(40, 167, 69, 0.10);\n     --t-accent-glow:     rgba(40, 167, 69, 0.15); /* tdb-accent-glow */\n     --t-accent-hover:    #1e8c3a;      /* tdb-accent-hover */\n   \n     /* Semantic colours */\n     --t-amber:           #b4690e;      /* tdb-amber */\n     --t-amber-dim:       rgba(180, 105, 14, 0.08);\n     --t-amber-border:    rgba(180, 105, 14, 0.22);\n     --t-cyan:            #0891b2;\n     --t-cyan-dim:        rgba(8, 145, 178, 0.08);\n     --t-cyan-border:     rgba(8, 145, 178, 0.22);\n     --t-blue:            #2563eb;\n     --t-blue-dim:        rgba(37, 99, 235, 0.08);\n     --t-blue-border:     rgba(37, 99, 235, 0.22);\n     --t-green-dim:       rgba(40, 167, 69, 0.08);\n     --t-green-border:    rgba(40, 167, 69, 0.22);\n   \n     /* Purple — tdb-purple */\n     --t-purple:          #5624d0;      /* tdb-purple */\n     --t-purple-light:    rgba(86, 36, 208, 0.07);  /* tdb-purple-light */\n     --t-purple-border:   rgba(86, 36, 208, 0.18);  /* tdb-purple-border */\n   \n     /* Reactor type colours */\n     --t-batch:           #b4690e;\n     --t-cstr:            #c0392b;\n     --t-pfr:             #2563eb;\n     --t-pbr:             #28a745;\n   \n     /* Borders */\n     --t-border:          #d1d7dc;      /* tdb-border */\n     --t-border-light:    #e8ecef;      /* tdb-border-light */\n     --t-border-mid:      #bbc1c8;\n   \n     /* Text — tdb-text scale */\n     --t-text:            #1c1d1f;      /* tdb-text */\n     --t-text-muted:      #4a4f5a;      /* tdb-text-muted */\n     --t-text-mid:        #3a3f4a;\n     --t-text-dim:        #6a6f73;      /* tdb-text-dim */\n     --t-text-sub:        #8a8f96;\n   \n     /* Font — identical to tdb-font */\n     --t-font:            'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n     --t-font-mono:       'Courier New', 'Courier', monospace;\n   \n     /* Spacing */\n     --t-space-xs:  6px;\n     --t-space-sm:  10px;\n     --t-space-md:  16px;\n     --t-space-lg:  24px;\n     --t-space-xl:  40px;\n     --t-space-2xl: 56px;\n   \n     /* Radii — tdb uses 6px (md), 4px (sm) */\n     --t-radius-sm: 4px;\n     --t-radius-md: 6px;\n     --t-radius-lg: 8px;\n   \n     --t-sidebar-w: 260px;\n   }\n   \n   /* ─── Reset ─────────────────────────────────────────────────── */\n   *,\n   *::before,\n   *::after {\n     box-sizing: border-box;\n     margin: 0;\n     padding: 0;\n   }\n   \n   /* ─── Scrollbar ─────────────────────────────────────────────── */\n   ::-webkit-scrollbar        { width: 5px; height: 5px; }\n   ::-webkit-scrollbar-track  { background: transparent; }\n   ::-webkit-scrollbar-thumb  { background: var(--t-border); border-radius: 3px; }\n   ::-webkit-scrollbar-thumb:hover { background: var(--t-border-mid); }\n   \n   /* ─── Container ─────────────────────────────────────────────── */\n   /* Base font matches TutorialsDashboard body: Inter 15px / 400 / 1.7 */\n   .cre-container {\n     font-family: var(--t-font);\n     background:  var(--t-bg);\n     color:       var(--t-text);\n     display:     flex;\n     height:      100%;\n     width:       100%;\n     font-size:   15px;\n     line-height: 1.7;\n     overflow:    hidden;\n   }\n   \n   /* ─── Main ──────────────────────────────────────────────────── */\n   .cre-main {\n     flex:       1;\n     overflow-y: auto;\n     overflow-x: hidden;\n     min-width:  0;\n     animation:  fadeIn 0.25s ease;\n   }\n   \n   .cre-main-inner {\n     margin:  0 auto;\n     padding: 52px 64px 88px;\n   }\n   \n   /* ─── Hero ──────────────────────────────────────────────────── */\n   .cre-hero {\n     margin-bottom:  var(--t-space-2xl);\n     padding-bottom: 32px;\n     border-bottom:  2px solid var(--t-text);\n   }\n   \n   /* Matches .tdb-header-tag exactly */\n   .cre-hero-tag {\n     font-family:    var(--t-font);\n     font-size:      13px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t-purple);\n     margin-bottom:  10px;\n   }\n   \n   /* Matches .tdb-header-title exactly */\n   .cre-hero h1 {\n     font-family:    var(--t-font);\n     font-size:      32px;\n     font-weight:    800;\n     line-height:    1.2;\n     letter-spacing: -0.5px;\n     margin-bottom:  12px;\n     color:          var(--t-text);\n   }\n   \n   /* Matches .tdb-header-desc exactly */\n   .cre-hero-desc {\n     font-family: var(--t-font);\n     font-size:   16px;\n     font-weight: 400;\n     color:       var(--t-text-muted);\n     max-width:   640px;\n     line-height: 1.7;\n     margin:      0;\n   }\n   \n   .cre-hero-meta {\n     display:    flex;\n     gap:        24px;\n     margin-top: 20px;\n     flex-wrap:  wrap;\n   }\n   \n   .cre-meta-item {\n     font-family: var(--t-font);\n     font-size:   12px;\n     font-weight: 400;\n     color:       var(--t-text-dim);\n     display:     flex;\n     align-items: center;\n     gap:         6px;\n   }\n   \n   .cre-meta-dot {\n     width:         6px;\n     height:        6px;\n     border-radius: 50%;\n     background:    var(--t-accent);\n     display:       inline-block;\n     flex-shrink:   0;\n   }\n   \n   /* ─── TOC box ───────────────────────────────────────────────── */\n   .cre-toc-box {\n     background:    var(--t-surface);\n     border:        1px solid var(--t-border);\n     border-left:   3px solid var(--t-accent);\n     border-radius: var(--t-radius-md);\n     padding:       22px 26px;\n     margin-bottom: 40px;\n     box-shadow:    0 2px 8px rgba(0, 0, 0, 0.06);\n   }\n   \n   /* Matches .tdb-card-tag label: 12px / 700 / uppercase / 0.8px tracking */\n   .cre-toc-box h3 {\n     font-family:    var(--t-font);\n     font-size:      12px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.8px;\n     color:          var(--t-accent);\n     margin-bottom:  14px;\n   }\n   \n   .cre-toc-grid {\n     display:               grid;\n     grid-template-columns: 1fr 1fr;\n     gap:                   6px 24px;\n   }\n   \n   /* Matches tdb-popup-bullets li: 13px / 400 / text-muted */\n   .cre-toc-link {\n     font-family:     var(--t-font);\n     font-size:       13px;\n     font-weight:     400;\n     color:           var(--t-blue);\n     text-decoration: none;\n     display:         flex;\n     align-items:     center;\n     gap:             6px;\n     padding:         2px 0;\n     transition:      color 0.15s;\n   }\n   .cre-toc-link:hover { color: var(--t-accent); }\n   \n   /* ─── Sections ──────────────────────────────────────────────── */\n   .cre-section {\n     margin-bottom:    var(--t-space-2xl);\n     scroll-margin-top: 24px;\n   }\n   \n   /* Matches .tdb-badge: 12px / 700 / 0.2px tracking / 3px 9px padding */\n   .cre-lec-badge {\n     display:        inline-block;\n     font-family:    var(--t-font);\n     font-size:      12px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.2px;\n     padding:        3px 9px;\n     border-radius:  var(--t-radius-sm);\n     margin-bottom:  14px;\n   }\n   .cre-lec-badge--lec1 {\n     background: rgba(180, 105, 14, 0.08);\n     color:      var(--t-amber);\n     border:     1px solid var(--t-amber-border);\n   }\n   .cre-lec-badge--lec8 {\n     background: var(--t-blue-dim);\n     color:      var(--t-blue);\n     border:     1px solid var(--t-blue-border);\n   }\n   \n   /* Matches .tdb-header-tag / tdb-card-tag label style */\n   .cre-section-label {\n     font-family:    var(--t-font);\n     font-size:      13px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t-purple);\n     margin-bottom:  8px;\n   }\n   \n   /* Matches tdb section heading style: 26px / 800 / -0.3px tracking */\n   .cre-section h2 {\n     font-family:    var(--t-font);\n     font-size:      26px;\n     font-weight:    800;\n     letter-spacing: -0.3px;\n     color:          var(--t-text);\n     margin-bottom:  6px;\n     line-height:    1.25;\n   }\n   \n   .cre-section-divider {\n     width:         40px;\n     height:        3px;\n     background:    var(--t-accent);\n     margin-bottom: 22px;\n     border-radius: 2px;\n   }\n   \n   /* Matches .tdb-card-title: 17px / 700 / -0.1px tracking */\n   .cre-section h3 {\n     font-family:    var(--t-font);\n     font-size:      17px;\n     font-weight:    700;\n     letter-spacing: -0.1px;\n     color:          var(--t-text);\n     margin:         28px 0 10px;\n   }\n   \n   /* Body copy — matches tdb-card-desc base: 400 weight, 1.65 lh, text-muted */\n   .cre-section p {\n     font-family:   var(--t-font);\n     font-size:     15px;\n     font-weight:   400;\n     margin-bottom: 14px;\n     color:         var(--t-text-muted);\n     line-height:   1.7;\n   }\n   \n   /* Matches tdb-popup-bullets: 400, text-muted, 1.55 lh */\n   .cre-section ul,\n   .cre-section ol {\n     font-family:   var(--t-font);\n     font-size:     14px;\n     font-weight:   400;\n     padding-left:  20px;\n     margin-bottom: 14px;\n     color:         var(--t-text-muted);\n     line-height:   1.65;\n   }\n   \n   .cre-section li { margin-bottom: 6px; }\n   \n   /* ─── Equation box ──────────────────────────────────────────── */\n   .cre-eq-box {\n     background:    var(--t-eq-bg);\n     border:        1px solid var(--t-border);\n     border-left:   3px solid var(--t-amber);\n     border-radius: var(--t-radius-md);\n     padding:       18px 22px;\n     margin:        18px 0;\n     overflow-x:    auto;\n   }\n   \n   .cre-eq-label {\n     font-family:    var(--t-font);\n     font-size:      11px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 1.5px;\n     color:          var(--t-text-dim);\n     margin-bottom:  8px;\n   }\n   \n   .cre-eq-main {\n     font-family: var(--t-font-mono);\n     font-size:   14px;\n     color:       var(--t-blue);\n     line-height: 2;\n   }\n   \n   .cre-eq-note {\n     font-family: var(--t-font);\n     font-size:   12px;\n     font-weight: 400;\n     color:       var(--t-text-dim);\n     margin-top:  8px;\n     line-height: 1.6;\n   }\n   \n   /* Matches .tdb-popup-desc: 14px / 400 / 1.65 / text-muted */\n   .cre-callout {\n     border-radius: var(--t-radius-md);\n     padding:       14px 18px;\n     margin:        18px 0;\n     line-height:   1.65;\n   }\n   .cre-callout p {\n     font-family: var(--t-font);\n     font-size:   14px;\n     font-weight: 400;\n     color:       var(--t-text-muted);\n     margin:      0;\n     line-height: 1.65;\n   }\n   .cre-callout--key  { background: var(--t-blue-dim);  border: 1px solid var(--t-blue-border);  }\n   .cre-callout--warn { background: var(--t-amber-dim); border: 1px solid var(--t-amber-border); }\n   .cre-callout--tip  { background: var(--t-green-dim); border: 1px solid var(--t-green-border); }\n   .cre-callout--info { background: var(--t-cyan-dim);  border: 1px solid var(--t-cyan-border);  }\n   \n   /* ─── Card grid ─────────────────────────────────────────────── */\n   .cre-card-grid {\n     display:               grid;\n     grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n     gap:                   14px;\n     margin:                20px 0;\n   }\n   \n   .cre-card {\n     background:    var(--t-surface);\n     border:        1px solid var(--t-border);\n     border-radius: var(--t-radius-md);\n     padding:       16px 18px;\n     transition:    border-color 0.18s, box-shadow 0.18s, transform 0.18s;\n     box-shadow:    0 2px 6px rgba(0, 0, 0, 0.06);\n   }\n   .cre-card:hover {\n     border-color: var(--t-accent);\n     box-shadow:   0 8px 28px rgba(0, 0, 0, 0.10);\n     transform:    translateY(-2px);\n   }\n   \n   .cre-card-icon {\n     font-size:     22px;\n     margin-bottom: 8px;\n   }\n   /* Matches .tdb-card-title: 17px / 700 / -0.1px */\n   .cre-card h4 {\n     font-family:    var(--t-font);\n     font-size:      17px;\n     font-weight:    700;\n     color:          var(--t-text);\n     margin-bottom:  6px;\n     letter-spacing: -0.1px;\n   }\n   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */\n   .cre-card p {\n     font-family: var(--t-font);\n     font-size:   14px;\n     font-weight: 400;\n     color:       var(--t-text-muted);\n     margin:      0;\n     line-height: 1.65;\n   }\n   \n   /* ─── Steps list ────────────────────────────────────────────── */\n   .cre-steps { margin: 20px 0; }\n   \n   .cre-step {\n     display:       flex;\n     gap:           16px;\n     margin-bottom: 20px;\n     align-items:   flex-start;\n   }\n   \n   .cre-step-num {\n     min-width:       32px;\n     height:          32px;\n     background:      var(--t-accent);\n     color:           #fff;\n     border-radius:   50%;\n     display:         flex;\n     align-items:     center;\n     justify-content: center;\n     font-family:     var(--t-font);\n     font-weight:     700;\n     font-size:       13px;\n     margin-top:      2px;\n     flex-shrink:     0;\n     box-shadow:      0 2px 8px var(--t-accent-glow);\n   }\n   \n   .cre-step-content { flex: 1; }\n   /* Matches .tdb-card-title: 17px / 700 / -0.1px */\n   .cre-step-content h4 {\n     font-family:    var(--t-font);\n     font-size:      17px;\n     font-weight:    700;\n     color:          var(--t-text);\n     margin-bottom:  6px;\n     letter-spacing: -0.1px;\n   }\n   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */\n   .cre-step-content p {\n     font-family: var(--t-font);\n     font-size:   14px;\n     font-weight: 400;\n     color:       var(--t-text-muted);\n     margin:      0 0 8px;\n     line-height: 1.65;\n   }\n   \n   /* ─── Example box ───────────────────────────────────────────── */\n   .cre-example-box {\n     background:    var(--t-surface);\n     border:        1px solid var(--t-border);\n     border-top:    3px solid var(--t-accent);\n     border-radius: var(--t-radius-md);\n     padding:       20px 24px;\n     margin:        20px 0;\n     box-shadow:    0 2px 6px rgba(0, 0, 0, 0.06);\n   }\n   \n   /* Matches .tdb-badge: 12px / 700 / 0.2px tracking */\n   .cre-example-tag {\n     font-family:    var(--t-font);\n     font-size:      12px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.2px;\n     color:          var(--t-accent);\n     margin-bottom:  8px;\n   }\n   \n   /* Matches .tdb-card-title: 17px / 700 / -0.1px */\n   .cre-example-box h4 {\n     font-family:    var(--t-font);\n     font-size:      17px;\n     font-weight:    700;\n     color:          var(--t-text);\n     margin-bottom:  10px;\n     letter-spacing: -0.1px;\n   }\n   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */\n   .cre-example-box p {\n     font-family:   var(--t-font);\n     font-size:     14px;\n     font-weight:   400;\n     color:         var(--t-text-muted);\n     margin-bottom: 10px;\n     line-height:   1.65;\n   }\n   \n   /* ─── Tables ────────────────────────────────────────────────── */\n   .cre-table {\n     width:           100%;\n     border-collapse: collapse;\n     margin:          20px 0;\n     font-family:     var(--t-font);\n     font-size:       13px;\n     background:      var(--t-surface);\n     border-radius:   var(--t-radius-md);\n     overflow:        hidden;\n     border:          1px solid var(--t-border);\n   }\n   \n   .cre-table thead { background: var(--t-panel); }\n   /* th: matches tdb-card-tag label (11px/700/uppercase/0.8px) */\n   .cre-table th {\n     padding:        10px 14px;\n     text-align:     left;\n     font-family:    var(--t-font);\n     font-size:      11px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 0.8px;\n     color:          var(--t-text-muted);\n     border-bottom:  1px solid var(--t-border);\n   }\n   /* td: matches tdb-popup-bullets (13px/400/1.55/text-muted) */\n   .cre-table td {\n     font-family:    var(--t-font);\n     font-size:      13px;\n     font-weight:    400;\n     padding:        10px 14px;\n     border-bottom:  1px solid var(--t-border-light);\n     color:          var(--t-text-muted);\n     vertical-align: top;\n     line-height:    1.55;\n   }\n   .cre-table tr:last-child td { border-bottom: none; }\n   .cre-table tr:hover td { background: rgba(40, 167, 69, 0.03); }\n   \n   /* ─── Reactor cards ─────────────────────────────────────────── */\n   .cre-reactor-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin: 20px 0; }\n   \n   .cre-reactor-card {\n     background:    var(--t-surface);\n     border:        1px solid var(--t-border);\n     border-radius: var(--t-radius-md);\n     overflow:      hidden;\n     box-shadow:    0 2px 6px rgba(0, 0, 0, 0.06);\n   }\n   \n   /* Matches tdb badge/tag label: 11px / 700 / uppercase / 1.5px tracking */\n   .cre-reactor-header {\n     padding:        12px 16px;\n     font-family:    var(--t-font);\n     font-size:      11px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 1.5px;\n   }\n   .cre-reactor-header--batch { background: rgba(180, 105, 14, 0.08); color: var(--t-batch); border-bottom: 1px solid rgba(180, 105, 14, 0.18); }\n   .cre-reactor-header--cstr  { background: rgba(192, 57, 43, 0.08);  color: var(--t-cstr);  border-bottom: 1px solid rgba(192, 57, 43, 0.18); }\n   .cre-reactor-header--pfr   { background: var(--t-blue-dim);        color: var(--t-pfr);   border-bottom: 1px solid var(--t-blue-border); }\n   .cre-reactor-header--pbr   { background: var(--t-green-dim);       color: var(--t-pbr);   border-bottom: 1px solid var(--t-green-border); }\n   \n   .cre-reactor-body { padding: 14px 16px; }\n   /* Matches .tdb-card-desc: 14px / 400 / 1.65 */\n   .cre-reactor-body p {\n     font-family:   var(--t-font);\n     font-size:     14px;\n     font-weight:   400;\n     color:         var(--t-text-muted);\n     margin-bottom: 10px;\n     line-height:   1.65;\n   }\n   .cre-reactor-eq {\n     font-family:   var(--t-font-mono);\n     font-size:     13px;\n     color:         var(--t-text-mid);\n     background:    var(--t-code-bg);\n     border:        1px solid var(--t-border-light);\n     border-radius: var(--t-radius-sm);\n     padding:       8px 12px;\n     margin-top:    8px;\n   }\n   .cre-reactor-eq span { color: var(--t-blue); }\n   \n   /* ─── Lecture divider ───────────────────────────────────────── */\n   .cre-lecture-divider {\n     border-top:  2px solid var(--t-text);\n     margin:      48px 0 40px;\n     padding-top: 40px;\n   }\n   /* Matches .tdb-header-tag exactly */\n   .cre-lecture-label {\n     font-family:    var(--t-font);\n     font-size:      13px;\n     font-weight:    700;\n     text-transform: uppercase;\n     letter-spacing: 2px;\n     color:          var(--t-purple);\n     margin-bottom:  8px;\n   }\n   /* Matches .tdb-header-title: 32px / 800 / -0.5px */\n   .cre-lecture-divider h2 {\n     font-family:    var(--t-font);\n     font-size:      32px;\n     font-weight:    800;\n     letter-spacing: -0.5px;\n     color:          var(--t-text);\n     margin-bottom:  8px;\n     line-height:    1.2;\n   }\n   /* Matches .tdb-header-desc: 16px / 400 / 1.7 */\n   .cre-lecture-divider p {\n     font-family: var(--t-font);\n     font-size:   16px;\n     font-weight: 400;\n     color:       var(--t-text-muted);\n     max-width:   640px;\n     line-height: 1.7;\n     margin:      0;\n   }\n   \n   /* ─── Inline code ───────────────────────────────────────────── */\n   .cre-inline-code {\n     font-family:   var(--t-font-mono);\n     font-size:     0.88em;\n     background:    var(--t-code-bg);\n     color:         var(--t-blue);\n     padding:       2px 6px;\n     border-radius: var(--t-radius-sm);\n     border:        1px solid var(--t-border-light);\n   }\n   .cre-mono {\n     font-family: var(--t-font-mono);\n     color:       var(--t-blue);\n   }\n   \n   /* ─── Footer ────────────────────────────────────────────────── */\n   .cre-footer {\n     border-top:  1px solid var(--t-border-light);\n     padding-top: 24px;\n     margin-top:  40px;\n     font-family: var(--t-font);\n     font-size:   12px;\n     font-weight: 400;\n     color:       var(--t-text-dim);\n     line-height: 1.6;\n   }\n   \n   /* ─── Images & Diagrams ─────────────────────────────────────── */\n   img {\n     max-width: 100%;\n     height: auto;\n     display: block;\n     margin: 20px auto;\n     border-radius: var(--t-radius-md);\n     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n     transition: transform 0.2s ease, box-shadow 0.2s ease;\n     border: 1px solid var(--t-border-light);\n   }\n   \n   img:hover {\n     transform: translateY(-2px);\n     box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);\n   }\n   \n   .cre-section img {\n     margin: 20px auto;\n     max-width: 90%;\n   }\n   \n   /* Image container for diagrams */\n   div[style*=\"textAlign: center\"] > img {\n     display: block;\n     margin: 16px auto;\n   }\n   \n   .diagram-caption {\n     font-family: var(--t-font);\n     font-size: 12px;\n     color: var(--t-text-dim);\n     text-align: center;\n     margin-top: 8px;\n     font-style: italic;\n   }\n   \n   /* ─── Animation ─────────────────────────────────────────────── */\n   @keyframes fadeIn {\n     from { opacity: 0; transform: translateY(8px); }\n     to   { opacity: 1; transform: translateY(0); }\n   }\n   \n   /* ─── Responsive ────────────────────────────────────────────── */\n   @media (max-width: 1200px) {\n     .cre-main-inner { padding: 40px 40px 64px; }\n   }\n   \n   @media (max-width: 900px) {\n     .cre-sidebar { display: none !important; }\n     .cre-main-inner {\n       padding:   28px 20px 52px;\n       max-width: 100%;\n     }\n     .cre-reactor-grid,\n     .cre-toc-grid { grid-template-columns: 1fr; }\n     .cre-hero h1 { font-size: 26px; }\n     .cre-hero-desc { font-size: 15px; }\n   }\n   \n   @media (max-width: 600px) {\n     .cre-card-grid { grid-template-columns: 1fr; }\n   }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
